import * as React from 'react';
import { KFLButton } from '@kamstrup/kamstrup-frontend-library';
import { AppKeys, newMsg } from '../../core/localization';
import Translate from '../shared/localization/localize';
import { useSecurity } from '../../libs/security/useSecurity';

const SignInButton: React.FC = () => {
  const { signIn } = useSecurity();
  return (
    <KFLButton
      id="unauthenticated-login-btn"
      variant="primary"
      onClick={signIn}
    >
      <Translate message={newMsg(AppKeys.topheader_signin)} />
    </KFLButton>
  );
};

export default SignInButton;
